import { AlertCommentBaseModel } from './alert-comment-base-model';
import { AlertCommentType } from './alert-comment-type';

export class AlertCommentModel extends AlertCommentBaseModel {
  type: AlertCommentType;
}
